module.exports = __webpack_public_path__ + "static/img/68.2277a88.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/68.png
// module id = PW/r
// module chunks = 1